import type { LoadStatusProps } from './types.tsx';

export const LoadStatus = ({ useProvider, shouldThrowError = false }: LoadStatusProps) => {
	// @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value. | TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
	const [{ fetchError, isFetching = false, promise, hasSuccessOnce = false } = {}] = useProvider();

	if (fetchError != null && shouldThrowError && !hasSuccessOnce) {
		throw fetchError;
	}

	if (isFetching && !hasSuccessOnce) {
		throw promise;
	}

	return null;
};
